import LegalScreen from './LegalScreen';

export default LegalScreen;
